import getSubstringBeforeFindString from '../helpers/getSubstringBeforeFindString'
import getSubstringAfterFindString from '../helpers/getSubstringAfterFindString'
import isEmpty from '../helpers/isEmpty'
//====================================================================
// summary fields arrays by item type (tab suffix)
//-------------------------------------------------
const summaryFieldsByTabSuffix = {
  //--------
  // common
  //--------
  common: [
    'rowNumber',
    'name',
    'short_description',
    'fill0',
    'held_image',
    'located_image',
    'stored_image',
    'worn_image',
    'equipped_image',
    'attached_image',
    'magic_image',
    'fill1',
    'tally_qty',
    'adjust_image',
    'tot_enc',
  ],
  healing: ['healing_type', 'recovers', 'delay'],
  poison: ['poison_type', 'pot', 'effect', 'delay', 'duration', 'resist', 'damage_dice'],
  specialist: ['delay', 'damage_dice', 'duration', 'resist'],
  //------------
  // containers
  //------------
  containers: [
    'fill2',
    'attachment_count',
    'attachment_items_image',
    'contents_image',
    'container_capacity',
    'container_size_short',
    'contents_count_total',
    'contents_enc',
  ],
  //--------
  // armour
  //--------
  armour: ['fill3', 'coverage', 'ap', 'hp', 'layer', 'pwr_storage', 'dex_pen'],
  //-----------
  // artefacts
  //-----------
  artefacts: [
    'short_description',
    'value',
    'image',
    'base_item',
    'fill2',
    'fill3',
    'pwr_storage',
    'rune_name',
    'artefact_type',
    'material',
    'quality',
    'age',
    'race',
  ],
}

function collapseUnifiedWornColumn(fields, tab_suffix) {
  if (tab_suffix === 'armour') {
    return fields
  }

  if (fields.includes('worn_image') && fields.includes('equipped_image')) {
    return fields.filter((field) => field !== 'equipped_image')
  }

  return fields
}
//====================================================================
// get item summary cols
//-----------------------
export default function getItemSummaryCols(active_tab, headings) {
  console.log('-----------------------')
  console.log('IN getItemSummaryCols active_tab:', active_tab)
  //----------
  // declares
  //----------
  let colNumbers = []
  let fields = []
  //------------------
  // check active tab
  //------------------
  let tab_prefix = getSubstringBeforeFindString(active_tab, '-')
  if (tab_prefix !== 'items') {
    console.error('*** getItemSummaryCols - Invalid sheet:', active_tab)
    return colNumbers
  }
  //------------------------
  // set field cols to show
  //------------------------
  const tab_suffix = getSubstringAfterFindString(active_tab, 'items-')
  console.log('tab_suffix = ', tab_suffix)
  //-----------------------
  // guard have tab suffix
  //-----------------------
  if (isEmpty(tab_suffix)) {
    console.warn(
      '*** getItemSummaryCols - No tab suffix found in active_tab:',
      active_tab,
      ' - defaulting to common',
    )
  }
  //===========================================================================================================
  // ALL
  //-----
  if (tab_suffix === 'all') {
    const base = summaryFieldsByTabSuffix.common
    // summary view: use common fields only (no container/contents cols)
    fields = [...base]

    if (!fields.includes('usable_image')) {
      const heldIdx = fields.indexOf('held_image')
      const insertIdx = heldIdx !== -1 ? heldIdx + 1 : fields.length
      fields.splice(insertIdx, 0, 'usable_image')
    }

    if (!fields.includes('campaign_ref')) {
      fields.push('campaign_ref')
    }

    //-------------------------------
    // ensure "type" column is present
    //-------------------------------
    if (!fields.includes('type')) {
      const nameIdx = fields.indexOf('name')
      const insertIdx = nameIdx !== -1 ? nameIdx + 1 : 2
      fields = [...fields.slice(0, insertIdx), 'type', ...fields.slice(insertIdx)]
    }

    //----------------------------------------
    // ensure "equipment_type" column present
    //----------------------------------------
    if (!fields.includes('equipment_type')) {
      const shortDescIdx = fields.indexOf('short_description')
      const insertIdx = shortDescIdx !== -1 ? shortDescIdx + 1 : 3
      fields = [...fields.slice(0, insertIdx), 'equipment_type', ...fields.slice(insertIdx)]
    }
    //===========================================================================================================
    // EQUIPMENT
    //-----------
  } else if (tab_suffix === 'equipment') {
    const base = summaryFieldsByTabSuffix.common
    // summary view: use common fields only (no container/contents cols)
    fields = [...base]
    //----------------------------------------
    // ensure "equipment_type" column present
    //----------------------------------------
    if (!fields.includes('equipment_type')) {
      const shortDescIdx = fields.indexOf('short_description')
      const insertIdx = shortDescIdx !== -1 ? shortDescIdx + 1 : 3
      fields = [...fields.slice(0, insertIdx), 'equipment_type', ...fields.slice(insertIdx)]
    }
    //===========================================================================================================
    // ARMOUR
    //--------
  } else if (tab_suffix === 'armour') {
    const base = summaryFieldsByTabSuffix.common
    const armourExtras = summaryFieldsByTabSuffix.armour || []
    //------------------------------------------------
    // add container details if not already in common
    //------------------------------------------------
    if (base.includes('coverage')) {
      console.log('*** getItemDetailCols - armour - common already has coverage field')
      // start from base and ensure all armour extras are present
      fields = [...base]
      for (const f of armourExtras) {
        if (!fields.includes(f)) {
          fields.push(f)
        }
      }
    } else {
      console.log('*** getItemDetailCols - armour - adding coverage field to common fields')
      // insert all armour extras (fill3, coverage, ap, hp, layer, dex_pen_percent, ...)
      fields = [...base.slice(0, 15), ...armourExtras, ...base.slice(15)]
    }
    //------------------------------
    // remove tally qty/adjust/worn
    //------------------------------
    if (
      fields.includes('tally_qty') &&
      fields.includes('adjust_image') &&
      fields.includes('worn_image')
    ) {
      fields = fields.filter((a) => a !== 'tally_qty' && a !== 'adjust_image' && a !== 'worn_image')
    }
    //===========================================================================================================
    // MELEE WEAPONS
    //---------------
  } else if (tab_suffix === 'melee-weapon') {
    const base = summaryFieldsByTabSuffix.common
    //-----------------
    // start from base
    //-----------------
    fields = [...base]
    //----------------------------------
    // ensure skilled column after name
    //----------------------------------
    if (!fields.includes('skilled')) {
      const nameIdx = fields.indexOf('name')
      const insertIdx = nameIdx !== -1 ? nameIdx + 1 : 2
      fields = [...fields.slice(0, insertIdx), 'skilled', ...fields.slice(insertIdx)]
    }
    //----------------------------------------------
    // add melee weapon summary cols if not present
    //----------------------------------------------
    const meleeExtras = [
      'fill3',
      'damage_dice',
      'ap',
      'hp',
      'pwr_storage',
      'impale_image',
      'usable_image',
    ]
    for (const f of meleeExtras) {
      if (!fields.includes(f)) {
        fields.push(f)
      }
    }
    //------------------------------
    // remove tally qty/adjust
    //------------------------------
    if (fields.includes('tally_qty') || fields.includes('adjust_image')) {
      fields = fields.filter((a) => a !== 'tally_qty' && a !== 'adjust_image')
    }
    //===========================================================================================================
    // RANGED WEAPONS
    //----------------
  } else if (tab_suffix === 'ranged-weapon') {
    const base = summaryFieldsByTabSuffix.common
    //-----------------
    // start from base
    //-----------------
    fields = [...base]
    //----------------------------------
    // ensure skilled column after name
    //----------------------------------
    if (!fields.includes('skilled')) {
      const nameIdx = fields.indexOf('name')
      const insertIdx = nameIdx !== -1 ? nameIdx + 1 : 2
      fields = [...fields.slice(0, insertIdx), 'skilled', ...fields.slice(insertIdx)]
    }
    //-----------------------------------------------
    // add ranged weapon summary cols if not present
    //-----------------------------------------------
    const rangedExtras = [
      'fill3',
      'damage_dice',
      'ap',
      'hp',
      'pwr_storage',
      'load',
      'range',
      'usable_image',
    ]
    for (const f of rangedExtras) {
      if (!fields.includes(f)) {
        fields.push(f)
      }
    }
    //------------------------------
    // remove tally qty/adjust
    //------------------------------
    if (fields.includes('tally_qty') || fields.includes('adjust_image')) {
      fields = fields.filter((a) => a !== 'tally_qty' && a !== 'adjust_image')
    }
  } else if (tab_suffix === 'artefact') {
    // console.log('IN ARTEFACTS')

    const base = summaryFieldsByTabSuffix.common
    //-----------------
    // start from base
    //-----------------
    fields = [...base]
    if (!fields.includes('campaign_ref')) {
      fields.push('campaign_ref')
    }
    //---------------------------------------------
    // add artefact details if not already present
    //---------------------------------------------
    const artefactExtras = summaryFieldsByTabSuffix.artefacts.filter((f) => f !== 'fill3')
    for (const f of artefactExtras) {
      if (!fields.includes(f)) {
        const fill3Idx = fields.indexOf('fill3')
        const insertAt = fill3Idx !== -1 ? fill3Idx + 1 : fields.length
        fields.splice(insertAt, 0, f)
      }
    }
    // console.log('fields with artefact extras = ', fields)
    //----------------------
    // remove unwanted cols
    //----------------------
    if (
      fields.includes('attached_image') ||
      fields.includes('tally_qty') ||
      fields.includes('adjust_image')
    ) {
      fields = fields.filter(
        (a) => a !== 'attached_image' && a !== 'tally_qty' && a !== 'adjust_image',
      )
    }
  } else if (tab_suffix === 'healing' || tab_suffix === 'poison' || tab_suffix === 'specialist') {
    const base = summaryFieldsByTabSuffix.common
    const tabExtras = summaryFieldsByTabSuffix[tab_suffix] || []
    fields = base.filter((field) => field !== 'campaign_ref')

    const shortDescIdx = fields.indexOf('short_description')
    const insertAt = shortDescIdx !== -1 ? shortDescIdx + 1 : fields.length
    fields.splice(insertAt, 0, ...tabExtras)
  } else {
    //===========================================================================================================
    // OTHERWISE
    //-----------
    fields = summaryFieldsByTabSuffix[tab_suffix] || summaryFieldsByTabSuffix.common
  }
  fields = collapseUnifiedWornColumn(fields, tab_suffix)
  // console.log('fields = ', fields)
  //--------------------------------
  // get headings idx for col names
  //--------------------------------
  for (let k = 0; k < fields.length; k++) {
    const idx = headings.findIndex((a) => a.field === fields[k])
    if (idx !== -1) {
      colNumbers.push(idx)
    }
  }
  return colNumbers
}
